import React from "react";

import Header from "./Header";
import Content from "./Content";
import Aside from "./Aside";
import Footer from "./Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";


function Users() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    const content = <div className={'content-wrapper'}>
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Usuarios</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                    </ol>
                                </div>
                                </div>
                            </div>
                        </div>
                        <section className="content">
                            <div className="container-fluid">
                                
                            </div>
                        </section>
                    </div>;

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
    },[]);

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} />
                    {content}
                <Footer />
            </div>
        );
    }

    return (
        <div className="alert alert-warning">No estás loggeado en el sistema.</div>
    );
}

export default Users;